import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { MessageService } from '@progress/kendo-angular-l10n';
import { CompositeFilterDescriptor, filterBy, process } from '@progress/kendo-data-query';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { images } from 'src/app/resources/images';
import { DialogService } from '@progress/kendo-angular-dialog';
import { ApiService } from 'src/app/services/http/api.service';
import { BaseHttpResponse } from 'src/app/models/base-http-response';
import { NotificationService } from '@progress/kendo-angular-notification';
import { User } from 'src/app/global-functions';
import { ExcelExportData } from "@progress/kendo-angular-excel-export";
import { DatePipe } from '@angular/common'
import { FormGroup, FormControl } from '@angular/forms';
import { MovementLUG } from 'src/app/models/movementlug.model';

@Component({
  selector: "app-movements-component",
  templateUrl: "./movements.component.html",
})
export class MovementsComponent implements OnInit {
  @ViewChild(DataBindingDirective) dataBinding?: DataBindingDirective;
  @ViewChild("container", { read: ViewContainerRef })
  public container: ViewContainerRef | undefined;
  public formGroup: FormGroup = new FormGroup({});
  public gridData: MovementLUG[] = [];
  public gridView: any[] = [];
  public filter: CompositeFilterDescriptor | undefined;
  public mySelection: string[] = [];
  public customMsgService: CustomMessagesService;

  constructor(public msgService: MessageService,
      private dialogService: DialogService, private api: ApiService, private notificationService: NotificationService, private datepipe: DatePipe) {
      this.customMsgService = this.msgService as CustomMessagesService;
      this.allData = this.allData.bind(this);

      this.formGroup = new FormGroup({
          dataDe: new FormControl(),
          dataAte: new FormControl(),
      });
  }

  public load() {
      let hoje = new Date();
      let mesPassado = new Date(new Date().setMonth(new Date().getMonth() - 1));

      this.formGroup.controls['dataDe'].setValue(mesPassado);
      this.formGroup.controls['dataAte'].setValue(hoje);

      let dataDe = this.datepipe.transform(this.formGroup.controls['dataDe'].value, 'yyyy-MM-dd');
      let dataAte = this.datepipe.transform(this.formGroup.controls['dataAte'].value, 'yyyy-MM-dd');
      let uri = "MovimentoLUG/GetMovimentosLUG?inicio=" + dataDe + "&fim=" + dataAte;

      this.api
          .getRequest<BaseHttpResponse<MovementLUG[]>>(uri)
          .then((data) => {
              this.gridData = data.value;
              this.gridView = this.gridData;
          })
          .catch((err) => { });
  }

  public loadPesquisa() {
      let dataDe = this.datepipe.transform(this.formGroup.controls['dataDe'].value, 'yyyy-MM-dd');
      let dataAte = this.datepipe.transform(this.formGroup.controls['dataAte'].value, 'yyyy-MM-dd');
      let uri = "MovimentoLUG/GetMovimentosLUG?inicio=" + dataDe + "&fim=" + dataAte;

      this.api
          .getRequest<BaseHttpResponse<MovementLUG[]>>(uri)
          .then((data) => {
              this.gridData = data.value;
              this.gridView = this.gridData;
          })
          .catch((err) => { });
  }

  public ngOnInit(): void {
      this.gridView = this.gridData;
      this.load();
  }

  public onTeamChange(pageSize: number): void {
      pageSize === 25
          ? (this.gridView = this.gridData.slice(pageSize, pageSize * 2))
          : (this.gridView = this.gridData.slice(0, pageSize));
  }

  public onFilter(inputValue: string): void {
      this.gridView = process(this.gridData, {
          filter: {
              logic: 'or',
              filters: [
                  {
                      field: this.getField,
                      operator: 'contains',
                      value: inputValue
                  }
              ]
          }
      }).data;

      this.dataBinding ? this.dataBinding.skip = 0 : null;
  }

  public getField = (args: MovementLUG) => {
      var data = this.datepipe.transform(args.data, 'yyyy-MM-dd HH:mm:ss')
      return `${args.nomeUtilizador} ${args.codigoFuncionario} ${args.nomeTipoMovimento} ${args.nomeArmario} ${args.nomeCompartimento} ${data} ${args.idCartao}`;
  }

  public photoURL(dataItem: any): string {
      const code: string = dataItem.imgId;
      const image: any = images;

      return image[code];
  }

  public flagURL(dataItem: any): string {
      const code: string = dataItem.country;
      const image: any = images;

      return image[code];
  }

  public toolTip(a: any): string{
      var anomalia = a.codigoAnomalia;
      if(anomalia == "" || anomalia == null){
          return "";
      }
      else{
          var t = `${this.customMsgService.translate('anomalia') + ": " + a.codigoAnomalia }
${this.customMsgService.translate('name') + ": " + a.nomeAnomalia}`;
          return t;
      }
  }
  
  public nomeTipoMovimento(a: any): string {
      return a.nomeTipoMovimento;
  }
  


  canList() {
      return User.canMovimentosList();
  }

public allData(): ExcelExportData {
        const result: ExcelExportData = {
                data: process(this.gridView, { filter: this.filter }).data.map((item: MovementLUG) => ({
                        ...item,
                        data: this.datepipe.transform(item.data, 'yyyy-MM-dd HH:mm:ss')
                })),
        };
        return result;
}

  public filterChange(filter: CompositeFilterDescriptor): void {
      this.filter = filter;
      this.gridData = filterBy(this.gridView, filter);
  }

  public pesquisar(): void {
      let dataDe = this.formGroup.controls['dataDe'].value;
      let dataAte = this.formGroup.controls['dataAte'].value;
      if (dataDe == null || dataAte == null) {
          this.notificationService.show({
              appendTo: this.container,
              content: this.customMsgService.translate('preencherIntervaloDatas'),
              animation: { type: 'slide', duration: 500 },
              position: { horizontal: 'center', vertical: 'top' },
              type: { style: 'error', icon: true },
              hideAfter: 4000
          });

      } else {
          this.loadPesquisa();
      }
  }
}
